import DashboardLayout from "layouts/DashboardLayout/DashboardLayout";

export default function CompanyJobsCreatePage() {
  return (
    <DashboardLayout>
      <div>CompanyJobsCreatePage</div>
    </DashboardLayout>
  );
}
